import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Box } from "@mui/material";
import ShippingSOAV2 from "pages/Dashboard/ReportingAnalytics/ShippingSOAV2";
import { setStoredUser } from "auth/authStorage";

// Render-only host for the SOA WhatsApp cron.
// Backend's puppeteer loads /print/shipping-soa-v2?customer_id=X&render_token=Y
// then waits for window.__SOA_READY__ before printing the page to PDF.
//
// The render token is a short-lived JWT for an admin user, minted by the
// backend (see app/services/soa/renderToken.js). We seed it into the same
// localStorage slot the normal login flow uses, so the existing axios
// interceptor (which reads getStoredUser().token) attaches it as a Bearer
// header on every API request from ShippingSOAV2.
function ShippingSoaPrint() {
  const [params] = useSearchParams();
  const [seeded, setSeeded] = useState(false);

  const customerId = params.get("customer_id");
  const renderToken = params.get("render_token");

  useEffect(() => {
    if (!customerId || !renderToken) return;
    setStoredUser({
      id: 0,
      token: renderToken,
      user_type: "A",
      name: "soa-render",
    });
    setSeeded(true);
  }, [customerId, renderToken]);

  if (!customerId || !renderToken) {
    return (
      <Box sx={{ p: 4, fontFamily: "Arial, sans-serif" }}>
        Missing customer_id or render_token in URL.
      </Box>
    );
  }
  if (!seeded) {
    return (
      <Box sx={{ p: 4, fontFamily: "Arial, sans-serif" }}>Initializing…</Box>
    );
  }

  return (
    <ShippingSOAV2
      printMode
      printCustomerId={customerId}
      printFromDate={params.get("from_date") || undefined}
      printToDate={params.get("to_date") || undefined}
    />
  );
}

export default ShippingSoaPrint;
